import {PoiCategory} from '../types/poi.types';
import {Poi} from '../react-app-env';
import {Events, EventType} from '../events/Events';

export const Api = {

  updatePoiCategory: async (poi: Poi, category: PoiCategory) => {
    Events.publish(EventType.ON_POI_UPDATED, {
      ...poi,
      category: category
    });
    return null;
  }

};
